export const appViewPosition = {
	computed: {
		$_appViewPosition_positionTop () {
      return;
			if (!this.$mq.isWV()) return
			return {
				position: 'fixed',
				top: this.$root.$data.appViewPosition.top + 'px',
				overflow: 'auto'
			} 
		},

		$_appViewPosition_positionBottom () {
			if (!this.$mq.isWV()) return
			return {
				position: 'fixed',
				bottom: this.$root.$data.appViewPosition.bottom + 'px',
				overflow: 'auto'
			} 
		},

		$_appViewPosition_margins () {
      return;
			if (!this.$mq.isWV()) return
			return {
				marginTop: this.$root.$data.appViewPosition.top + 'px',
				marginBottom: this.$root.$data.appViewPosition.bottom + 'px'
			}
		},

		$_appViewPosition_transformY () {
      return;
      
			if (!this.$mq.isWV()) return
			return {
				transform: 'translateY(' + this.$root.$data.appViewPosition.top + 'px)'
			}
		},

		$_appViewPosition_transformYfromBottom () {
			if (!this.$mq.isWV()) return
			return {
				transform: 'translateY(-' + this.$root.$data.appViewPosition.top + 'px)'
			}
		}
	}
}